import DashboardNew from './DashboardNew'

export default DashboardNew
